import axios from "axios";
import { toast } from "react-toastify";
import { UrlApi } from "../Keys";
import moment from "moment/moment";

let loadingToast = null;

const ToastLoading = (msj) => {
  loadingToast = toast.info(msj, {
    theme: "dark",
    position: "top-center",
    autoClose: false,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
  });
};

const ToastSuccess = (msj) => {
  toast.success(msj, {
    theme: "dark",
    position: "top-center",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    onOpen: () => {
      if (loadingToast !== null) {
        toast.dismiss(loadingToast);
      }
    },
  });
};

const ToastError = (msj) => {
  toast.error(msj, {
    theme: "dark",
    position: "top-center",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    onOpen: () => {
      if (loadingToast !== null) {
        toast.dismiss(loadingToast);
      }
    },
  });
};

const dataInicial = {
  tipoNovedadPago: [],
  divisas: [],
  pendientesAprobacion: [],
  getPendientesAprobacion: false,
  AprobadasPendientesLiquidacion: [],
  getPendientesLiquidacion: false,
  liquidadas: [],
  getLiquidadas: false,
  loadSolicitarLiquidacion: "",
  loadAprobarRechazarLiquidacion: "",
  loadingNovedadesEmpleados: false,
  novedadesEmp: []
};

const LOADING_NP = "LOADING_NP";
const NOVEDAD_PAGO = "NOVEDAD_PAGO";
const NOVEDAD_PAGO_ERROR = "NOVEDAD_PAGO_ERROR";

const LOADING_DIVISAS = "LOADING_DIVISAS";
const DIVISAS = "DIVISAS";
const DIVISAS_ERROR = "DIVISAS_ERROR";

const LOADING_PENDIENTES_APROBACION = "LOADING_PENDIENTES_APROBACION";
const PENDIENTES_APROBACION = "PENDIENTES_APROBACION";
const PENDIENTES_APROBACION_ERROR = "PENDIENTES_APROBACION_ERROR";

const LOADING_PENDIENTES_LIQUIDACION = "LOADING_PENDIENTES_LIQUIDACION";
const APROBADAS_PENDIENTES_LIQUIDACION = "APROBADAS_PENDIENTES_LIQUIDACION";
const APROBADAS_PENDIENTES_LIQUIDACION_ERROR =
  "APROBADAS_PENDIENTES_LIQUIDACION_ERROR";

const LOADING_LIQUIDADAS = "LOADING_LIQUIDADAS";
const LIQUIDADAS = "LIQUIDADAS";
const LIQUIDADAS_ERROR = "LIQUIDADAS_ERROR";

const LOADING_SOLICITAR_LIQUIDACION = "LOADING_SOLICITAR_LIQUIDACION";
const EXITO_SOLICITAR_LIQUIDACION = "EXITO_SOLICITAR_LIQUIDACION";
const ERROR_SOLICITAR_LIQUIDACION = "ERROR_SOLICITAR_LIQUIDACION";

const LOADING_APROBAR_RECHAZAR_LIQUIDACION = "LOADING_APROBAR_RECHAZAR_LIQUIDACION"
const EXITO_APROBAR_RECHAZAR_LIQUIDACION = "EXITO_APROBAR_RECHAZAR_LIQUIDACION"
const ERROR_APROBAR_RECHAZAR_LIQUIDACION = "ERROR_APROBAR_RECHAZAR_LIQUIDACION"

const LOADING_NOVEDADES_EMPLEADOS = "LOADING_NOVEDADES_EMPLEADOS"
const NOVEDADES_EMPLEADOS = "NOVEDADES_EMPLEADOS"
const NOVEDADES_EMPLEADOS_ERROR = "NOVEDADES_EMPLEADOS_ERROR"

export default function novedadesLiquidacionReducer(
  state = dataInicial,
  action
) {
  switch (action.type) {
    case NOVEDAD_PAGO:
      return { ...state, tipoNovedadPago: action.payload };
    case DIVISAS:
      return { ...state, divisas: action.payload };
    case LOADING_PENDIENTES_APROBACION:
      return {
        ...state,
        getPendientesAprobacion: action.getPendientesAprobacion,
      };
    case PENDIENTES_APROBACION:
      return {
        ...state,
        pendientesAprobacion: action.payload,
        getPendientesAprobacion: action.getPendientesAprobacion,
      };
    case PENDIENTES_APROBACION_ERROR:
      return {
        ...state,
        getPendientesAprobacion: action.getPendientesAprobacion,
      };
    case LOADING_PENDIENTES_LIQUIDACION:
      return {
        ...state,
        getPendientesLiquidacion: action.getPendientesLiquidacion,
      };
    case APROBADAS_PENDIENTES_LIQUIDACION:
      return {
        ...state,
        AprobadasPendientesLiquidacion: action.payload,
        getPendientesLiquidacion: action.getPendientesLiquidacion,
      };
    case APROBADAS_PENDIENTES_LIQUIDACION_ERROR:
      return {
        ...state,
        getPendientesLiquidacion: action.getPendientesLiquidacion,
      };
    case LOADING_LIQUIDADAS:
      return { ...state, getLiquidadas: action.getLiquidadas };
    case LIQUIDADAS:
      return {
        ...state,
        liquidadas: action.payload,
        getLiquidadas: action.getLiquidadas,
      };
    case LIQUIDADAS_ERROR:
      return { ...state, getLiquidadas: action.getLiquidadas };
    case LOADING_SOLICITAR_LIQUIDACION:
      return {
        ...state,
        loadSolicitarLiquidacion: action.resultado,
      };
    case EXITO_SOLICITAR_LIQUIDACION:
      return {
        ...state,
        loadSolicitarLiquidacion: action.resultado,
      };
    case ERROR_SOLICITAR_LIQUIDACION:
      return {
        ...state,
        loadSolicitarLiquidacion: action.resultado,
      };
    case LOADING_APROBAR_RECHAZAR_LIQUIDACION:
      return {
        ...state,
        loadAprobarRechazarLiquidacion: action.resultado,
      };
    case EXITO_APROBAR_RECHAZAR_LIQUIDACION:
      return {
        ...state,
        loadAprobarRechazarLiquidacion: action.resultado,
      };
    case ERROR_APROBAR_RECHAZAR_LIQUIDACION:
      return {
        ...state,
        loadAprobarRechazarLiquidacion: action.resultado,
      };
    case LOADING_NOVEDADES_EMPLEADOS:
      return { ...state, loadingNovedadesEmpleados: action.loadingNovedadesEmpleados }
    case NOVEDADES_EMPLEADOS:
      return { ...state, novedadesEmp: action.payload, loadingNovedadesEmpleados: action.loadingNovedadesEmpleados }
    case NOVEDADES_EMPLEADOS_ERROR:
      return { ...state, loadingNovedadesEmpleados: action.loadingNovedadesEmpleados }
    default:
      return { ...state };
  }
}

export const tipoNovedadPago = (token) => async (dispatch) => {
  dispatch({
    type: LOADING_NP,
  });

  try {
    var entidad = "new_tipodenovedaddepagos";
    // var fetch =
    //   "<entity name='new_tipodenovedaddepago'>" +
    //   "<attribute name='new_name'/>" +
    //   "<attribute name='new_informa'/>" +
    //   "<attribute name='new_tipodenovedaddepagoid'/>" +
    //   "<order attribute='new_name' descending='false'/>" +
    //   "</entity>";
    var fetch = `<entity name="new_tipodenovedaddepago">
    <attribute name="statecode"/>
    <attribute name="new_name"/>
    <order attribute="new_codigo" descending="false"/>
    <attribute name="new_informa"/>
    <attribute name="new_importe"/>
    <attribute name="new_tipodenovedaddepagoid"/>
    <filter type="and">
    <condition attribute="statecode" operator="eq" value="0"/>
    <filter type="and"><condition attribute="new_informa" operator="eq" value="100000002"/>
    </filter>
    </filter>
    </entity>`

    const response = await axios.post(
      `${UrlApi}api/consultafetch`,
      {
        entidad: entidad,
        fetch: fetch,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({
      type: NOVEDAD_PAGO,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: NOVEDAD_PAGO_ERROR,
    });
  }
};

export const divisas = (token) => async (dispatch) => {
  dispatch({
    type: LOADING_DIVISAS,
  });

  try {
    var entidad = "transactioncurrencys";
    var fetch =
      "<entity name='transactioncurrency'>" +
      "<attribute name='transactioncurrencyid'/>" +
      "<attribute name='currencyname'/>" +
      "<attribute name='isocurrencycode'/>" +
      "<attribute name='currencysymbol'/>" +
      "<attribute name='exchangerate'/>" +
      "<attribute name='currencyprecision'/>" +
      "<attribute name='new_fechadenovedad' />" +
      "<attribute name='statuscode' />" +
      "<order attribute='currencyname' descending='false'/>" +
      "<filter type='and'>" +
      "<condition attribute='statecode' operator='eq' value='0'/>" +
      "</filter>" +
      "</entity>";

    const response = await axios.post(
      `${UrlApi}api/consultafetch`,
      {
        entidad: entidad,
        fetch: fetch,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({
      type: DIVISAS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: DIVISAS_ERROR,
    });
  }
};

export const pendientesAprobacion =
  (token, aprobadorUsuarioPortalRH) => async (dispatch) => {
    dispatch({
      type: LOADING_PENDIENTES_APROBACION,
      getPendientesAprobacion: false,
    });

    try {
      var entidad = "new_novedads";
      var fetch =
        "<entity name='new_novedad'>" +
        "<attribute name='new_novedadid' />" +
        "<attribute name='new_name' />" +
        "<attribute name='createdon' />" +
        "<attribute name='new_tipodenovedad' />" +
        "<attribute name='new_tipodenovedaddepago' />" +
        "<attribute name='new_informa' />" +
        "<attribute name='new_cantidadhoras' />" +
        "<attribute name='new_empleado' />" +
        "<attribute name='new_aprobador' />" +
        "<attribute name='statuscode' />" +
        "<attribute name='new_fechaliquidacin' />" +
        "<attribute name='new_fechadenovedad' />" +
        "<attribute name='new_fechadeaprobacin' />" +
        "<attribute name='transactioncurrencyid' />" +
        "<order attribute='createdon' descending='true' />" +
        "<filter type='and'>" +
        "<condition attribute='new_usuarioportalaprobadornovedad' operator='like' value='" +
        aprobadorUsuarioPortalRH +
        "' />" +
        "<condition attribute='statuscode' operator='eq' value='1' />" +
        "<condition attribute='new_tipodenovedad' operator='eq' value='100000002' />" +
        "<condition attribute='new_aprobacion' operator='ne' value='1' />" +
        "</filter>" +
        "</entity>";

      const response = await axios.post(
        `${UrlApi}api/consultafetch`,
        {
          entidad: entidad,
          fetch: fetch,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: PENDIENTES_APROBACION,
        payload: response.data,
        getPendientesAprobacion: true,
      });
    } catch (error) {
      dispatch({
        type: PENDIENTES_APROBACION_ERROR,
        getPendientesAprobacion: true,
      });
    }
  };

export const aprobadasPendientesLiquidacion = (token, usuarioPortalRH) => async (dispatch) => {
  dispatch({
    type: LOADING_PENDIENTES_LIQUIDACION,
    getPendientesLiquidacion: false,
  });

  try {
    var entidad = "new_novedads";
    var fetch =
      "<entity name='new_novedad'>" +
      "<attribute name='new_novedadid' />" +
      "<attribute name='new_name' />" +
      "<attribute name='createdon' />" +
      "<attribute name='new_tipodenovedad' />" +
      "<attribute name='new_tipodenovedaddepago' />" +
      "<attribute name='new_informa' />" +
      "<attribute name='new_fechadenovedad' />" +
      "<attribute name='new_empleado' />" +
      "<attribute name='statuscode' />" +
      "<attribute name='new_fechaliquidacin' />" +
      "<attribute name='new_fechadenovedad' />" +
      "<attribute name='new_fechadeaprobacin' />" +
      "<attribute name='transactioncurrencyid' />" +
      "<order attribute='new_fechadeaprobacin' descending='true' />" +
      "<filter type='and'>" +
        "<condition attribute='new_usuarioportalaprobadornovedad' operator='like' value='" +
        usuarioPortalRH +
        "' />" +
        "<condition attribute='statuscode' operator='eq' value='100000000' />" +
        "<condition attribute='new_tipodenovedad' operator='eq' value='100000002' />" +
        "<condition attribute='new_liquidada' operator='eq' value='0' />" +
      "</filter>" +
      "</entity>";

    const response = await axios.post(
      `${UrlApi}api/consultafetch`,
      {
        entidad: entidad,
        fetch: fetch,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({
      type: APROBADAS_PENDIENTES_LIQUIDACION,
      payload: response.data,
      getPendientesLiquidacion: true,
    });
  } catch (error) {
    dispatch({
      type: APROBADAS_PENDIENTES_LIQUIDACION_ERROR,
      getPendientesLiquidacion: true,
    });
  }
};

export const liquidadas = (token, usuarioPortalRH) => async (dispatch) => {
  dispatch({
    type: LOADING_LIQUIDADAS,
    getLiquidadas: false,
  });

  try {
    var entidad = "new_novedads";
    var fetch = `<entity name="new_novedad">
        <attribute name="new_name"/>
        <attribute name="statecode"/>
        <attribute name="new_importe"/>
        <attribute name="new_fechadenovedad"/>
        <attribute name="new_empleado"/>
        <attribute name="transactioncurrencyid"/>
        <attribute name="new_fechaliquidacin"/>
        <attribute name="statuscode"/>
        <attribute name="new_tipodenovedad"/>
        <attribute name="new_tipodenovedaddepago"/>
        <order attribute="new_fechadenovedad" descending="true"/>
        <attribute name="new_porcentaje"/>
        <attribute name="new_cantidadhoras"/>
        <attribute name="new_cantidadfinal"/>
        <attribute name="new_cantidad"/>
        <attribute name="new_novedadid"/>
        <filter type="and">
          <condition attribute="new_tipodenovedad" operator="eq" value="100000002"/>
          <condition attribute="statuscode" operator="eq" value="100000001"/>
          <condition attribute="new_usuarioportalaprobadornovedad" operator="like" value="${usuarioPortalRH}"/>
        </filter>
      </entity>`
    const response = await axios.post(
      `${UrlApi}api/consultafetch`,
      {
        entidad: entidad,
        fetch: fetch,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({
      type: LIQUIDADAS,
      payload: response.data,
      getLiquidadas: true,
    });
  } catch (error) {
    dispatch({
      type: LIQUIDADAS_ERROR,
      getLiquidadas: true,
    });
  }
};

export const solicitarLiquidacion = (token, datos, empleado, autor) => async (dispatch) => {
  if(autor) {
    dispatch({
      type: LOADING_SOLICITAR_LIQUIDACION,
      resultado: "LOADING",
    });
    ToastLoading("Procesando...")
    return new Promise((resolve, reject) => {
      if (Object.keys(datos).length > 0 && token) {
        axios.post(`${UrlApi}api/hrfactors/solicitarliquidacion`,
          {
            "new_empleado": empleado,
            "createdby": autor,
            "new_tipodenovedaddepago": datos.tipoDeNovedadDePago.value,
            "new_tipodenovedad": datos.novedadDePago ? Number(datos.novedadDePago.value) : 0,
            "new_informa": datos.novedadDePago ? Number(datos.novedadDePago.value) : 0,
            "new_cantidadhoras": datos.cantidadHoras ? Number(datos.cantidadHoras) : 0,
            "new_cantidad": datos.cantidad ? Number(datos.cantidad) : 0,
            "new_cantidadfinal": datos.cantidadFinal ? Number(datos.cantidadFinal) : 0,
            "new_porcentaje": datos.porcentaje ? Number(datos.porcentaje.value) : 0,
            "transactioncurrencyid": datos.divisa ? datos.divisa.value : "",
            "new_importe": datos.importe ? Number(datos.importe) : 0,
          }, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
          .then((response) => {
            dispatch({
              type: EXITO_SOLICITAR_LIQUIDACION,
              resultado: "EXITO",
              payload: response.data,
            });

            ToastSuccess("Liquidación cargada con éxito");
            resolve(response.data);
          })
          .catch((error) => {
            console.log(error);

            dispatch({
              type: ERROR_SOLICITAR_LIQUIDACION,
              resultado: "ERROR",
            });

            ToastError("Ha ocurrido un error en la carga de la liquidación");
            reject(error);
          });
      }
    });
  } else {
    ToastError("Ha ocurrido un error de privilegios de usuario");
  }
};

export const aprobarRechazarLiquidacion = (token, datos) => async (dispatch) => {
  dispatch({
    type: LOADING_APROBAR_RECHAZAR_LIQUIDACION,
    resultado: "LOADING",
  });
  ToastLoading("Procesando...")
  console.log("datos", datos)
  return new Promise((resolve, reject) => {
    if (Object.keys(datos).length > 0 && token) {
      axios.put(`${UrlApi}api/hrfactors/aprobarrechazarnovedad`,
        {
          "new_novedadId": datos.id,
          "new_fechadenovedad": datos.fechaNovedad ? moment(datos.fechaNovedad).format('YYYY-MM-DD') : "",
          "new_tipodenovedaddepago": datos.tipoNovedadPagoSelect ? datos.tipoNovedadPagoSelect.value : "",
          "new_informa": 0,
          "transactioncurrencyid": datos.divisa ? datos.divisa.value : "",
          "new_aprobar": datos.aprobar ? Number(datos.aprobar) : 0,
          "new_fechadeaprobacin": datos.fechaAprobacion ? moment(datos.fechaAprobacion).format('YYYY-MM-DD') : "",
          "new_motivoderechazo": datos.motivoDelRechazo,
          "new_cantidadhoras": datos.cantidadHoras
        }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => {
          dispatch({
            type: EXITO_APROBAR_RECHAZAR_LIQUIDACION,
            resultado: "EXITO",
            payload: response.data,
          });

          ToastSuccess("Liquidación actualizada con éxito");
          resolve(response.data);
        })
        .catch((error) => {
          console.log(error);

          dispatch({
            type: ERROR_APROBAR_RECHAZAR_LIQUIDACION,
            resultado: "ERROR",
          });

          ToastError(error.response.data);
          reject(error);
        });
    }
  });
};

export const novedadesEmpleados = (token, empeladoid) => async (dispatch) => {
  dispatch({
    type: LOADING_NOVEDADES_EMPLEADOS,
    loadingNovedadesEmpleados: true,
  });

  try {
    var entidad = "new_empleados";
    var fetch =
      "<entity name='new_empleado'>" +
      "<attribute name='new_name' />" +
      "<attribute name='new_cuitcuil' />" +
      "<attribute name='new_correoelectronico' />" +
      "<attribute name='new_numerolegajo' />" +
      "<attribute name='new_empleadoid' />" +
      "<order attribute='new_numerolegajo' descending='false' />" +
      "<filter type='and'>" +
      "<filter type='or'>" +
      "<condition attribute='new_empleadoid' operator='eq' uitype='new_empleado' value='" + empeladoid + "' />" +
      "<condition attribute='new_reportaaid' operator='eq' uitype='new_empleado' value='" + empeladoid + "' />" +
      "</filter>" +
      "</filter>" +
      "</entity>";

    const response = await axios.post(
      `${UrlApi}api/consultafetch`,
      {
        entidad: entidad,
        fetch: fetch,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({
      type: NOVEDADES_EMPLEADOS,
      payload: response.data,
      loadingNovedadesEmpleados: false,
    });
  } catch (error) {
    dispatch({
      type: NOVEDADES_EMPLEADOS_ERROR,
      loadingNovedadesEmpleados: false,
    });
  }
}